import { useOrganizationSettingsQuery } from '@/hooks/queries/useOrganizationSettingsQuery';
import { useOrganizationSettingsStore } from '@/store/organization-settings.store';

/**
 * Hook that provides time formatting functions with effective settings baked in.
 * Combines useOrganizationSettingsQuery (for effective settings) with
 * useOrganizationSettingsStore (for formatting utilities).
 */
export function useTimeFormat() {
  const { data: settingsData } = useOrganizationSettingsQuery();
  const { formatTime, parseTime, getTimeFormat } = useOrganizationSettingsStore();
  const effectiveSettings = settingsData?.effectiveSettings;

  return {
    formatTime: (hours: number) => formatTime(hours, effectiveSettings),
    parseTime: (timeString: string) => parseTime(timeString, effectiveSettings),
    getTimeFormat: () => getTimeFormat(effectiveSettings),
  };
}
